





















import {
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'
import { ApolloError, NetworkStatus } from 'apollo-client'

import CustomSelectTemplate from '@/components/organisms/h/item/hierarchy/CustomSelectTemplate.vue'
import {
  emitHierarchySelect,
  itemHierarchyType,
  emitHierarchySearch,
  emitCustomSelectSelect,
} from '@/types/entities'
import {
  UiPCausalNamesDocument,
  UiPCausalNameEdge,
  Where,
} from '@/types/generated/graphql'
import { MAX_COUNT } from '@/utils/constant'
import Toast, { genNotifyMessage } from '@/utils/toast'

export default defineComponent({
  components: { CustomSelectTemplate },
  props: {
    where: {
      type: Array as PropType<Where[]>,
      default: () => [],
    },
    itemHierarchyType: {
      type: String as PropType<itemHierarchyType>,
      default: '',
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  apollo: {
    uiPCausalNames: {
      query: UiPCausalNamesDocument,
      variables() {
        return this.searchCond
      },
      skip: true,
      fetchPolicy: 'cache-and-network',
      error(e: ApolloError) {
        Toast.error(this, {
          message: genNotifyMessage('e.list', 'causal', e),
        })
      },
    },
  },
  created() {
    this.$apollo.queries.uiPCausalNames.skip = false
    this.isSkipQuery = false
  },
  data() {
    return {
      uiPCausalNames: { edges: [] },
      // 表示を制御するためのフラグ（データを触ると想定しない挙動となるため用意した）
      isSkipQuery: true,
      totalCount: 0,
      first: MAX_COUNT,
    }
  },
  computed: {
    isLoading() {
      return this.$apollo.queries.uiPCausalNames.loading
    },
    causalList() {
      return this.uiPCausalNames.edges.map((ele: UiPCausalNameEdge) => {
        return {
          value: ele.node?.causalCd,
          text: ele.node?.causalName,
          key: ele.node?.causalCd,
        }
      })
    },
    searchCond(props: any) {
      return {
        where: props.where,
        orderBy: [],
        first: this.first,
      }
    },
  },
  watch: {
    where(newVal) {
      this.resetFirst()
    },
    uiPCausalNames(data) {
      this.totalCount = this.uiPCausalNames.totalCount
    },
  },
  methods: {
    changeSelected(emitParams: emitCustomSelectSelect) {
      const setectedMetaInfo = this.uiPCausalNames.edges.filter(
        (ele: UiPCausalNameEdge) => {
          const key = ele.node?.causalCd
          if (key) {
            for (const selKey of emitParams.keyList) {
              if (selKey.indexOf(key) !== -1) {
                return true
              }
            }
          }
        }
      )
      const params: emitHierarchySelect = {
        itemHierarchyType: 'Causal',
        selected: emitParams.selectList,
        selectedCount: emitParams.selectedCount,
        setectedMetaInfo: setectedMetaInfo,
      }
      this.$emit('change-selected', params)
    },
    onSearchWord(params: emitHierarchySearch) {
      console.log('search-word')
      this.$emit('search-word', params)
    },
    onSearch(params: emitHierarchySearch) {
      this.$emit('search', params)
    },
    countOverOk(params: any) {
      this.first = params
    },
    resetFirst() {
      this.first = MAX_COUNT
    },
  },
})
